<template>
  <div
    class="h-15 w-full flex justify-between items-center px-6 py-4 bg-neutral-background-default shrink-0 border-b border-neutral-border-default"
  >
    <div class="text-xl font-semibold">Users</div>
    <UserSettingsFloatingMenu v-slot="{ show }">
      <button
        class="font-semibold text-sm uppercase items-center flex flex-nowrap text-nowrap gap-4"
        @click.stop="show"
      >
        <p
          class="font-medium text-base rounded-full size-10 flex justify-center items-center bg-primary-50 text-primary-500"
        >
          {{ user?.firstName?.charAt(0) }}{{ user?.lastName?.charAt(0) }}
        </p>
      </button>
    </UserSettingsFloatingMenu>
  </div>
  <div class="flex-1">
    <div>
      <UsersList />
    </div>
  </div>
</template>

<script lang="ts" setup>
import UsersList from './Users/UsersList.vue'
import UserSettingsFloatingMenu from './Settings/UserSettings/UserSettingsFloatingMenu.vue'
import { injectStrict } from '@app/utils/injectStrict'
import { AuthKey } from '@app/injectionKeys'
const { user } = injectStrict(AuthKey)
</script>
